import React from 'react'
import BarcodeFormat from '@zxing/library/esm/core/BarcodeFormat'
import BarcodeScannerComponent from './lib'

/**
 * @param { string } codeType: AZTEC | CODABAR | CODE_39 | CODE_93 | CODE_128 | DATA_MATRIX | EAN_8 | EAN_13 | ITF | MAXICODE | PDF_417 | QR_CODE | RSS_14 | RSS_EXPANDED | UPC_A | UPC_E | UPC_EAN_EXTENSION
 * @param { function } onScanned handle function
 *
 * Example usage:
 * <Scanner codeType='EAN_13' onScanned={code => console.log('EAN_13', code)} />
 * <Scanner codeType='CODE_128' onScanned={code => console.log('CODE_128', code)} />
 */
export const BarcodeScanner = ({ codeType, onScanned }) => {
  const [stopStream, setStopStream] = React.useState(false)
  
  React.useEffect(() => {
    // stopStream has to be set to true before component unmount according to the issue mentioned here https://www.npmjs.com/package/react-qr-barcode-scanner
    return () => setStopStream(true)
  }, [])
  
  return (
    <BarcodeScannerComponent
      stopStream={stopStream}
      onUpdate={(_, result) => {
        if (
          result &&
          (! codeType || BarcodeFormat[result.getBarcodeFormat()] === codeType) && // if codeType prop is not provided, all code types are allowed
          onScanned
        )
          onScanned(result.getText())
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/complex/scanner/index.js